import Vue from 'vue';
import { VueMaskDirective } from 'v-mask';
import VueInputFacade from 'vue-input-facade';
import './disableAll';

Vue.directive('mask', VueMaskDirective);
Vue.use(VueInputFacade);
